import _ from 'lodash';
import Cleave from 'cleave.js';

const arrayIncludes = (array, value) => array.indexOf(value) !== -1;
// valid support states
const STATES = ['', 'error', 'success', 'disabled'];

export default {
  name: 'MInputMask',
  props: {
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      default: null,
      required: true,
      validator(value) {
        return (
          value === null
          || typeof value === 'string'
          || value instanceof String
          || typeof value === 'number'
        );
      },
    },
    // https://github.com/nosir/cleave.js/blob/master/doc/options.md
    options: {
      type: Object,
      default: () => ({}),
    },
    // Set this prop as `false` to emit masked value
    raw: {
      type: Boolean,
      default: true,
    },
    state: {
      type: String,
      default: '',
      validator: state => arrayIncludes(STATES, state),
    },
    symbol: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      cleave: null,
      onValueChangedFn: null,
    };
  },
  computed: {
    getClasses() {
      let classes = 'form-input inline-block w-full';

      if (this.symbol) {
        classes += ' pl-12';
      }
      if (this.state === 'success') {
        classes += ' border border-green-500 bg-green-200 text-green-700 placeholder-green-700';
      } else if (this.state === 'error') {
        classes += ' border border-red-500 bg-red-200 text-red-600 placeholder-red-600';
      } else if (this.state === 'disabled') {
        classes += ' bg-gray-300';
      }

      return classes;
    },
  },
  methods: {
    getOptions(options) {
      // Preserve original callback
      this.onValueChangedFn = options.onValueChanged;

      return Object.assign({}, options, {
        onValueChanged: this.onValueChanged,
      });
    },
    onValueChanged(event) {
      const value = this.raw ? event.target.rawValue : event.target.value;
      this.$emit('input', value);

      // Call original callback method
      if (typeof this.onValueChangedFn === 'function') {
        this.onValueChangedFn.call(this, event);
      }
    },
    onBlur() {
      this.$emit('blur', this.value);
    },
  },
  watch: {
    options: {
      deep: true,
      handler(newOptions, oldOptions) {
        if (_.isEqual(newOptions, oldOptions)) return;
        this.cleave.destroy();
        this.cleave = new Cleave(this.$el, this.getOptions(newOptions));
        this.cleave.setRawValue(this.value);
      },
    },
    value(newValue) {
      if (!this.cleave) return;

      // when v-model is not masked (raw)
      if (this.raw && newValue === this.cleave.getRawValue()) return;
      //  when v-model is masked (NOT raw)
      if (!this.raw && newValue === this.$el.value) return;
      // Lastly set newValue
      this.cleave.setRawValue(newValue);
    },
  },
  render(el) {
    return el('input', {
      class: this.getClasses,
      attrs: {
        id: this.id,
        type: this.type,
        value: this.value, // Cleave.js will set this as initial value,
        disabled: this.state === 'disabled',
        placeholder: this.placeholder,
        autocomplete: 'off',
      },
      on: {
        blur: this.onBlur,
      },
    });
  },
  mounted() {
    if (this.cleave) return;
    this.cleave = new Cleave(this.$el, this.getOptions(this.options));
  },
  beforeUnmount() {
    if (!this.cleave) return;

    this.cleave.destroy();
    this.cleave = null;
    this.onValueChangedFn = null;
  },
};
